import { makeConverter } from "../dbUtils"
import type { KnowledgeItemHistory } from "./types"

export const knowledgeItemHistoryConverter =
  makeConverter<KnowledgeItemHistory>()
